"use strict";
/**
 * Error Handling & Observability - Shared Error Models
 * Platform-wide error types for consistent error handling across frontend, Lambda, and services
 */
Object.defineProperty(exports, "__esModule", { value: true });
